import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Login from "../login/login";
import Dasboard from "../dasboard/dashboard";
import React from 'react';
import clienteAxios from "../../axios";
import ModalConfirm from '../ModalConfirm';

const Reservas = () => {
    
    const [reservas, setReservas] = useState([]);
    const [nuevaReserva, setNuevaReserva] = useState({ mesa_id: "", nombre_cliente: "", fecha_reserva: "", numero_invitados: "", informacion_contacto: "" });
    const [editandoReservaId, setEditandoReservaId] = useState(null);
    const [reservaEditada, setReservaEditada] = useState({ mesa_id: "", nombre_cliente: "", fecha_reserva: "", numero_invitados: "", informacion_contacto: "" });
    const [reservaSeleccionada, setReservaSeleccionada] = useState(null);
    const [mensajeExito, setMensajeExito] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [reservaAEliminar, setReservaAEliminar] = useState(null); // Nueva variable para eliminar
    const [busqueda, setBusqueda] = useState(""); // Estado para la barra de búsqueda


    const inputRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        obtenerReservas();
    }, []);


 
    useEffect(() => {
        obtenerReservas();
    }, []);

    // Obtener lista de reservas
    const obtenerReservas = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "reservas"
            });
            setReservas(response.data.data[0]);
        } catch (error) {
            console.log(error);
        }
    };

    // Función para manejar el cambio en la barra de búsqueda
    const handleBusqueda = (e) => {
        setBusqueda(e.target.value.toLowerCase());
    };

    // Filtrar las reservas en función del término de búsqueda
    const reservasFiltradas = reservas.filter((reserva) => {
        return (
            (reserva.nombre_cliente || "").toLowerCase().includes(busqueda) ||
            (reserva.fecha_reserva || "").toLowerCase().includes(busqueda) ||
            (reserva.informacion_contacto || "").toLowerCase().includes(busqueda) ||
            (reserva.mesa_id || "").toString().toLowerCase().includes(busqueda) ||
            (reserva.numero_invitados || "").toString().toLowerCase().includes(busqueda)
        );
    });

    // Función para agregar nueva reserva
    const handleAgregarReserva = async (e) => {
        e.preventDefault();

        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Agregar",
                modulo: "reservas",
                mesa_id: nuevaReserva.mesa_id,
                nombre_cliente: nuevaReserva.nombre_cliente,
                fecha_reserva: nuevaReserva.fecha_reserva,
                numero_invitados: nuevaReserva.numero_invitados,
                informacion_contacto: nuevaReserva.informacion_contacto
            });

            setNuevaReserva({ mesa_id: "", nombre_cliente: "", fecha_reserva: "", numero_invitados: "", informacion_contacto: "" });
            obtenerReservas();
        } catch (error) {
            console.log(error);
        }
    };

    // Función para editar una reserva existente
    const editarReserva = (idReserva, reservaActual) => {
        setEditandoReservaId(idReserva);
        setReservaEditada(reservaActual);
        setReservaSeleccionada(idReserva);
        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.focus();
                inputRef.current.setSelectionRange(0, 0);
            }
        }, 0);
    };


    // Función para guardar los cambios de la reserva editada
    const guardarReservaEditada = async (idReserva) => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Actualizar",
                modulo: "reservas",
                id: idReserva,
                mesa_id: reservaEditada.mesa_id,
                nombre_cliente: reservaEditada.nombre_cliente,
                fecha_reserva: reservaEditada.fecha_reserva,
                numero_invitados: reservaEditada.numero_invitados,
                informacion_contacto: reservaEditada.informacion_contacto
            });

            setEditandoReservaId(null);
            setReservaSeleccionada(null);
            obtenerReservas();
        } catch (error) {
            console.log(error);
        }
    };

    // Función para borrar una reserva
    const borrarReserva = async (idReserva) => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Eliminiar",
                modulo: "reservas",
                id: idReserva
            });

            obtenerReservas();
        } catch (error) {
            console.log(error);
        }
    };

    // Función para borrar una reserva
    const confirmarEliminarReserva = (idReserva) => {
        setShowConfirmModal(true);
        setReservaAEliminar(idReserva);
    };

    const ejecutarEliminarReserva = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Eliminiar",
                modulo: "reservas",
                id: reservaAEliminar
            });

            setShowConfirmModal(false);
            obtenerReservas();
        } catch (error) {
            console.log(error);
        }
    };

    const cancelarSeleccion = () => {
        setReservaSeleccionada(null);
        setEditandoReservaId(null);
    };

    return (
        <>
            <ModalConfirm
                show={showConfirmModal}
                message="¿Estás seguro de que quieres eliminar esta reserva?"
                onConfirm={ejecutarEliminarReserva}
                onCancel={() => setShowConfirmModal(false)}
            />

            <Dasboard  />
            <main className="-mt-32">
                <div className="mx-auto max-w-7xl px-4 pb-12 sm:px-6 lg:px-8">
                    <div className="rounded-lg bg-white px-5 py-6 shadow sm:px-6 max-w-full overflow-hidden">
                        <h2 className="font-bold mb-6 mt-8">Agregar nueva reserva</h2>


                        <form onSubmit={handleAgregarReserva}>
                            <input
                                type="text"
                                value={nuevaReserva.mesa_id}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    // Solo permite números y un máximo de 5 caracteres
                                    if (/^\d*$/.test(value) && value.length <= 5) {
                                        setNuevaReserva({ ...nuevaReserva, mesa_id: value });
                                    }
                                }}
                                placeholder="ID de la mesa"
                                className="border rounded-lg p-2 mr-2 mt-2"
                            />

                            <input
                                type="text"
                                value={nuevaReserva.nombre_cliente}
                                onChange={(e) => setNuevaReserva({ ...nuevaReserva, nombre_cliente: e.target.value })}
                                placeholder="Nombre del cliente"
                                className="border rounded-lg p-2 mr-2 mt-2"
                                maxLength={50}
                            />
                            <input
                                type="date"
                                value={nuevaReserva.fecha_reserva}
                                onChange={(e) => setNuevaReserva({ ...nuevaReserva, fecha_reserva: e.target.value })}
                                placeholder="Fecha de reserva"
                                className="border rounded-lg p-2 mr-2 mt-2"
                            />
                            <input
                                type="text"
                                value={nuevaReserva.numero_invitados}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    // Solo permite números y un máximo de 5 caracteres
                                    if (/^\d*$/.test(value) && value.length <= 5) {
                                        setNuevaReserva({ ...nuevaReserva, numero_invitados: value });
                                    }
                                }}
                                placeholder="Número de invitados"
                                className="border rounded-lg p-2 mr-2 mt-2"
                                maxLength={5}
                            />

                            <input
                                type="text"
                                value={nuevaReserva.informacion_contacto}
                                onChange={(e) => setNuevaReserva({ ...nuevaReserva, informacion_contacto: e.target.value })}
                                placeholder="Información de contacto"
                                className="border rounded-lg p-2 mr-2 mt-2"
                                maxLength={10}
                            />
                            <button type="submit" className="bg-green-500 rounded text-white px-2 py-1 mt-2">
                                Agregar Reserva
                            </button>
                        </form>

                        {mensajeExito && (
                            <p className="text-pink-500 mt-2">Reserva agregada exitosamente</p>
                        )}
                        <h2 className="text-2xl font-bold mb-6 mt-4">Reservas</h2>

                        {/* Barra de búsqueda */}
                        <input
                            type="text"
                            placeholder="Buscar reserva..."
                            value={busqueda}
                            onChange={handleBusqueda}
                            className="border rounded-lg p-2 mb-4 w-full"
                        />
                        <ul>
                            {reservasFiltradas.map((reserva) => (
                                <li key={reserva.id} className="border p-4 rounded-lg mb-4 cursor-pointer"
                                    onClick={() => setReservaSeleccionada(reserva.id)}>
                                    <div className="relative">

                                        {editandoReservaId === reserva.id ? (

                                            <div className="flex flex-col">
                                                <label><strong>Cliente:</strong></label>
                                                <input
                                                    type="text"
                                                    ref={inputRef}
                                                    value={reservaEditada.nombre_cliente}
                                                    onChange={(e) => setReservaEditada({ ...reservaEditada, nombre_cliente: e.target.value })}
                                                    className="border rounded-lg p-2 mb-2"
                                                    maxLength={50}
                                                />

                                                <label><strong>Fecha:</strong></label>
                                                <input
                                                    type="date"
                                                    value={reservaEditada.fecha_reserva}
                                                    onChange={(e) => setReservaEditada({ ...reservaEditada, fecha_reserva: e.target.value })}
                                                    className="border rounded-lg p-2 mb-2"
                                                />

                                                <label><strong>Mesa ID:</strong></label>
                                                <input
                                                    type="text"
                                                    value={reservaEditada.mesa_id}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        // Solo permite números y un máximo de 5 caracteres
                                                        if (/^\d*$/.test(value) && value.length <= 5) {
                                                            setReservaEditada({ ...reservaEditada, mesa_id: value });
                                                        }
                                                    }}
                                                    className="border rounded-lg p-2 mb-2"
                                                    maxLength={5}
                                                />


                                                <label><strong>Número de Invitados:</strong></label>
                                                <input
                                                    type="number"
                                                    value={reservaEditada.numero_invitados}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        // Limita el valor a números y un máximo de 5 caracteres
                                                        if (/^\d*$/.test(value) && value.length <= 5) {
                                                            setReservaEditada({ ...reservaEditada, numero_invitados: value });
                                                        }
                                                    }}
                                                    placeholder="Número de Invitados"
                                                    className="border rounded-lg p-2 mb-2"
                                                    maxLength={5}
                                                />


                                                <label><strong>Información de Contacto:</strong></label>
                                                <input
                                                    type="text"
                                                    value={reservaEditada.informacion_contacto}
                                                    onChange={(e) => setReservaEditada({ ...reservaEditada, informacion_contacto: e.target.value })}
                                                    className="border rounded-lg p-2 mb-2"
                                                    maxLength={10}
                                                />

                                                <div className="flex">
                                                    <button onClick={() => guardarReservaEditada(reserva.id)}
                                                        className="bg-green-500 text-white rounded px-2 py-1 mr-2">Guardar</button>
                                                    <button onClick={() => setEditandoReservaId(null)}
                                                        className="bg-gray-500 text-white rounded px-2 py-1">Cancelar</button>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="flex flex-col">
                                                <span><strong>Cliente:</strong> {reserva.nombre_cliente}</span>
                                                <span><strong>Fecha:</strong> {reserva.fecha_reserva}</span>
                                                <span><strong>Mesa ID:</strong> {reserva.mesa_id}</span>
                                                <span><strong>Número de Invitados:</strong> {reserva.numero_invitados}</span>
                                                <span><strong>Información de Contacto:</strong> {reserva.informacion_contacto}</span>
                                            </div>
                                        )}


                                        {reservaSeleccionada === reserva.id && !editandoReservaId && (
                                            <>
                                                <div className="flex items-center ">
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            editarReserva(reserva.id, reserva);
                                                        }}
                                                        className="bg-gray-500 text-white rounded px-2 py-1 mr-2 hover:bg-gray-400"
                                                    >
                                                        Editar Reserva
                                                    </button>

                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            confirmarEliminarReserva(reserva.id);
                                                        }}
                                                        className="bg-red-600 text-white rounded px-2 py-1 mr-2 hover:bg-red-500"
                                                    >
                                                        Borrar Reserva
                                                    </button>

                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            cancelarSeleccion();
                                                        }}
                                                        className="absolute top-[-0.5rem] right-0 text-gray-500 hover:text-red-500 p-2 text-3xl"
                                                    >
                                                        &times;
                                                    </button>
                                                </div>

                                            </>
                                        )}
                                    </div>
                                </li>
                            ))}
                        </ul>


                    </div>
                </div>
            </main>


        </>
    );
};

export default Reservas;
